
  // Export
  module.exports =
  {

    // Install scripts
    install:
    {

      // Method-wide scripts
      _init: function ()
      {

        // On clicking the install button
        $('#install').not('.js-ignore').click(function ()
        {
  
          // Disable the button
          $(this).prop('disabled', true)
  
          // Submit the form
          $('form').submit()
  
        }
        ).addClass('js-ignore')

        // Get the password script
        $.getScript(APPLICATION._PATH_PREFIX + 'includes/js/password.js?v=' + APPLICATION._PASSWORD_VERSION, function ()
        {

          // On generating the password
          $('#generate_account_password').click(function ()
          {

            // Generate the password
            PasswordGenerator.generate(function (password)
            {
          
              // Show the generated password
              $('#generated_account_password').val(password)
          
              // Enter the password
              $('#account_password').val(password)

            }
            )

          })

        }
        )

        // On clicking the generated password
        $('#generated_account_password').not('.js-ignore').click(function ()
        {
          this.select()
        }
        ).addClass('js-ignore')

      }

    }

  }